import script from "./roomCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./roomCalendar.vue?vue&type=script&setup=true&lang=js"

import "./roomCalendar.vue?vue&type=style&index=0&id=4935f024&lang=less"

const __exports__ = script;

export default __exports__